import React from 'react';
import { string, object, func } from 'prop-types';
import styled from 'styled-components';
import ReactMarkdown from 'react-markdown';
import { format } from '@olxbr/mojo-jojo/utils/string';
import withVisibilityToggle from '../../enhancements/withVisibilityToggle';
import Consumption from '../../components/consumption/Consumption';

const Container = styled.div`
  padding: 10px 10px 32px;
  position: relative;
  display: flex;
  flex-direction: column;
`;

const Image = styled.img`
  display: none;
  height: 29px;
  object-fit: contain;
  @media(min-width:1000px) {
    display: inline;
  }
`;

const Section = styled.div`
  margin: 22px auto 16px;
  flex-grow: ${({ grow }) => (grow ? '1' : 'initial')}
  display: flex;
  align-items: center;
`;

const Title = styled.h1`
  line-height: 1.31;
  display: flex;
  justify-content: center;
  margin-left: 4px;

  font-size : 1.3em;
  font-weight: bold;
  text-align: center;
  color: #4A4A4A;

  @media(min-width:1000px) {
    font-size : 36px;
    text-align: ${({ hasIcon }) => (hasIcon ? 'left' : 'center')};
  }
`;

const Subtitle = styled(ReactMarkdown)`
  margin-top: 8px;
  line-height: 1.4;
  font-size: 14px;
  color: #4a4a4a;
  text-align: center;
  strong {
    font-weight: bold;
  }
  @media(min-width:1000px) {
    font-size : 20px;
  }
`;

const AdditionalInfo = styled.div`
  color: #6E0AD6;
  font-size: 14x;
  font-weight: 700;
  display: flex;
  justify-content: center;
  padding: 8px 0 20px;
  cursor: pointer;
  @media(min-width:1000px) {
    font-size : 20px;
  }
`;

const Icon = withVisibilityToggle(Image);
const ConsumptionWithVisibilityToggle = withVisibilityToggle(Consumption);

const FeeHeader = ({
  content, limits, icon, openModal,
}) => (
  <Container>
    <Section grow={(icon === null)}>
      <Icon data-e2e="title-icon" showIf={icon} src={icon} alt="Atenção" />
      <Title hasIcon={!!icon}>{format(content.title, { consumption: limits.consumption.value, categoryName: limits.consumption.categoryName })}</Title>
    </Section>
    <ConsumptionWithVisibilityToggle
      consumption={limits.consumption.value}
      categoryName={limits.consumption.categoryName}
      dueDate={limits.consumption.dueDate}
      text={content.consumption}
      showIf={limits.consumption.show}
    />
    {content.additionalInfo && <AdditionalInfo onClick={openModal}>{content.additionalInfo}</AdditionalInfo>}
    <Subtitle hasIcon={!!icon}>{content.subtitle}</Subtitle>
  </Container>
);

FeeHeader.propTypes = {
  icon: string,
  limits: object.isRequired,
  content: object.isRequired,
  openModal: func.isRequired,
};

FeeHeader.defaultProps = {
  icon: null,
};

export default FeeHeader;
